module.exports = __webpack_public_path__ + "img/bestsaller-sticky.0483f2ed.svg";